import { FieldType } from 'modules/domains';
import {
  isBooleanFieldType,
  isNumberFieldType,
  isDateFieldType,
  isStringFieldType,
} from 'modules/domains/segmentation/utils';
import { AbsoluteDateValue, BooleanValue, StringValue } from '../domain';

export const getDefaultValue = (type: FieldType) => {
  if (isBooleanFieldType(type)) return new BooleanValue(false);
  if (isNumberFieldType(type)) return null;
  if (isDateFieldType(type)) return new AbsoluteDateValue(new Date().toISOString());
  if (isStringFieldType(type)) return new StringValue('');
  else throw new Error("can't get default value");
};
